export default __webpack_public_path__ + "static/media/Ali_Haydar(Resume).f7880c80.pdf";